
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_6a7og_17",
  "full-width": "awsui_full-width_8cbea_6a7og_44",
  "refresh": "awsui_refresh_8cbea_6a7og_47",
  "disabled": "awsui_disabled_8cbea_6a7og_53",
  "selected": "awsui_selected_8cbea_6a7og_116",
  "icon": "awsui_icon_8cbea_6a7og_127",
  "with-text": "awsui_with-text_8cbea_6a7og_131",
  "with-no-text": "awsui_with-no-text_8cbea_6a7og_140",
  "root": "awsui_root_8cbea_6a7og_145",
  "segment-part": "awsui_segment-part_8cbea_6a7og_177",
  "grouped": "awsui_grouped_8cbea_6a7og_201",
  "grouped-only": "awsui_grouped-only_8cbea_6a7og_201",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_6a7og_205",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_6a7og_216",
  "grouped-in-error": "awsui_grouped-in-error_8cbea_6a7og_223",
  "grouped-in-warning": "awsui_grouped-in-warning_8cbea_6a7og_228",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_6a7og_243",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_6a7og_267",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_6a7og_294",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_6a7og_321",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_6a7og_345",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_8cbea_6a7og_372",
  "grouped-vertical-only": "awsui_grouped-vertical-only_8cbea_6a7og_372",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_6a7og_402",
  "grouped-validation": "awsui_grouped-validation_8cbea_6a7og_412",
  "select": "awsui_select_8cbea_6a7og_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_6a7og_428",
  "segment-count-3": "awsui_segment-count-3_8cbea_6a7og_435",
  "segment-count-4": "awsui_segment-count-4_8cbea_6a7og_442",
  "segment-count-5": "awsui_segment-count-5_8cbea_6a7og_449",
  "segment-count-6": "awsui_segment-count-6_8cbea_6a7og_456",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_6a7og_463"
};
  